import { Loader, SearchCustomer } from '../../Widgets';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import ArthaGateway from 'service/ArthaGateway';
import { Account, Party, Receipt } from 'service';
import toast, { Toaster } from 'react-hot-toast';

export const NewReceipt = () => {
    const appData = useSelector((state: RootState) => state.appdata);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [receipt, setReceipt] = useState<Receipt>(new Receipt());
    const [accounts, setAccounts] = useState<Account[]>([]);
    const [pendingSales, setPendingSales] = useState<any[]>([]);
    const paymentTypes = ["Cash", "UPI", "Cheque", "NEFT", "RTGS", "IMPS"];

    const navigate = useNavigate();
    const handleFocus = (event: any) => event.target.select();

    useEffect(() => {
        if (appData.party) {
            setReceipt({ ...receipt, party: appData.party });
        }
        if (appData.sale) {
            setReceipt({ ...receipt, party: appData.sale.party });
        }
        setIsLoading(false);
    }, [appData]);

    useEffect(() => {
        setReceipt({ ...receipt, accountId: 6, paymentType: "Cash", allocations: [{ saleId: 0, amount: 0, saleVoucherNumber: "" }], amount: 0 });
        loadBankAcounts();
    }, []);

    useEffect(() => {
        if (appData && appData.sale) {
            setPendingSales([{ id: appData.sale.id, voucherNumber: appData.sale.voucherNumber, date: appData.sale.date, billAmount: appData.sale.billAmount, pendingAmount: appData.sale.billAmount }]);
            setReceipt({ ...receipt, accountId: 6, paymentType: "Cash", allocations: [{ saleId: appData.sale.id, amount: appData.sale.billAmount, saleVoucherNumber: appData.sale.voucherNumber }], amount: 0 });
        }
        if (receipt.party && receipt.party.id > 0) {
            ArthaGateway.getPendingInvoices(receipt.party.id).then((data) => {
                setPendingSales(data.entries);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [receipt.party]);

    const loadBankAcounts = () => {
        setIsLoading(true);       
        ArthaGateway
            .getAccounts("", 2)
            .then((data) => {
                setAccounts(data.entries);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const addAllocation = () => {
        setReceipt({ ...receipt, allocations: [...receipt.allocations, { saleId: 0, amount: 0, saleVoucherNumber: "" }] });
    }

    const removeAllocation = (index: number) => {
        let allocations = receipt.allocations;
        allocations.splice(index, 1);
        setReceipt({ ...receipt, allocations: [...allocations] });
        updateAmount();
    }

    const updateAmount = () => {
        let amount = 0;
        receipt.allocations.map((allocation) => {
            amount += allocation.amount;
        });
        setReceipt({ ...receipt, amount: amount });
    }

    const saveReceipt = () => {
        if (!receipt) { return; }

        if (receipt.allocations.length === 0) {
            toast('Please add products to the order', { position: 'bottom-center', className: 'btn bg-danger' });
            return;
        }

        receipt.date = moment().format("YYYY-MM-DD");
        receipt.series = "2025-2026";
        receipt.transactionType = "Receipt";
        receipt.incomeAccountId = 14;
        receipt.incomeAccount = { id: 14, name: "Sales" };
        const foundAccount = accounts.find((account) => account.id === receipt.accountId);
        if (foundAccount) {
            receipt.account = foundAccount;
        } 

        ArthaGateway
            .saveReceipt(receipt)
            .then((data) => {
                toast('Receipt saved successfully', { position: 'bottom-center', className: 'btn bg-success' });
                setTimeout(() => {
                    navigate("/receipts");
                }, 2000);
            })
            .catch(error => {
                console.log(error);
            });
    }

    const updateReceiptNotes = (e: any) => {
        setReceipt({ ...receipt, notes: e.target.value });
    }

    const handleCustomerSelected = (party: Party) => {
        setReceipt({ ...receipt, party: party });
    }

    const selectAccount = (accountId: number) => {
        let account = accounts.find((account) => account.id === accountId);
        if (account) {
            setReceipt({ ...receipt, accountId: accountId, account: account });
        }
    }

    const updateSaleId = (e: any, index: number) => {
        let saleId = parseInt(e.target.value);
        let sale = pendingSales.find((invoice) => invoice.id === saleId);
        if(sale) {
            receipt.allocations[index].saleId = saleId;
            receipt.allocations[index].saleVoucherNumber = sale.voucherNumber;
            setReceipt({ ...receipt, allocations: receipt.allocations });
        }
    }

    const updateSaleAllocationAmount = (e: any, index: number) => {
        let amount = parseFloat(e.target.value);
        let allocations = { ...receipt.allocations };
        let selectedAllocation = allocations[index];
        if (selectedAllocation.saleId === 0) {
            toast.error("Please select an invoice first");
            return;
        }

        let invoice = pendingSales.find((invoice) => invoice.id === selectedAllocation.saleId);
        if (invoice && amount > invoice.pendingAmount) {
            toast.error("Amount cannot be greater than invoice amount");
            amount = invoice.pendingAmount;
        }

        allocations[index].amount = amount;
        setReceipt({ ...receipt, allocations: allocations });
        updateAmount();
    }

    const currencyFormat = (value: number) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page page-new-order app-page-shell'>
            {isLoading &&
                <Loader />
            }
            {!isLoading &&
                <>
                    <div><Toaster /></div>
                    <div className='container'>
                        <div className='app-page-header'>
                            <h2>New Receipt</h2>
                            <p>Create and allocate payment against pending invoices.</p>
                        </div>
                        {!receipt?.party &&
                            <div className="row mb-3">
                                <div className="col-md-12 px-0">
                                    <SearchCustomer onCustomerSelected={handleCustomerSelected} />
                                </div>
                            </div>
                        }
                        {receipt?.party &&
                            <>
                                <div className='app-panel'>
                                    <div className='app-soft-card mb-2'>
                                        <div className='text-muted small'>Customer</div>
                                        <h4 className='mb-1'>{receipt.party?.name}</h4>
                                        <div className='text-muted'>{receipt.party?.mobileNumber}</div>
                                    </div>
                                    <div className='row mt-2'>
                                        <div className='col-12 col-md-6'>
                                            <div className='form-group'>
                                                <label>Account</label>
                                                <select
                                                    className="form-select"
                                                    value={receipt.accountId}
                                                    onChange={(e) => selectAccount(parseInt(e.target.value))}>
                                                    <option value="0">Select Account</option>
                                                    {accounts.map((account, index) => (
                                                        <option key={index} value={account.id}>{account.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row mt-2'>
                                        <div className='col-12 col-md-6'>
                                            <div className='form-group'>
                                                <label>Payment Type</label>
                                                <select
                                                    className="form-select"
                                                    value={receipt.paymentType}
                                                    onChange={(e) => setReceipt({ ...receipt, paymentType: e.target.value })}>
                                                    <option value="0">Select Payment Type</option>
                                                    {paymentTypes.map((paymentType, index) => (
                                                        <option key={index} value={paymentType}>{paymentType}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className='col-12 col-md-6'>
                                            <div className='form-group'>
                                                <label>Reference No.</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={receipt.referenceNumber}
                                                    onChange={(e) => setReceipt({ ...receipt, referenceNumber: e.target.value })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='mt-2'>
                                        {receipt.allocations && receipt.allocations.map((allocation, index) => (
                                            <div className='app-soft-card mb-2' key={index}>
                                                <div className="row g-2 align-items-end">
                                                    <div className="col-12 col-md-8">
                                                        <label className='form-label'>Invoice</label>
                                                        <select className="form-select" value={allocation.saleId} onChange={(e) => updateSaleId(e, index)}>
                                                            <option value="0">Select Invoice</option>
                                                            {pendingSales.map((invoice, index) => (
                                                                <option key={index} value={invoice.id}>{invoice.voucherNumber} | {moment(invoice.date).format("D/M/YYYY")} | {currencyFormat(invoice.billAmount)}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-10 col-md-3">
                                                        <label className='form-label'>Amount</label>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={allocation.amount}
                                                            onChange={(e) => updateSaleAllocationAmount(e, index)}
                                                            onFocus={handleFocus}
                                                        />
                                                    </div>
                                                    {receipt.allocations.length > 1 &&
                                                        <div className="col-2 col-md-1 text-end">
                                                            <div className="btn btn-outline-danger btn-sm" onClick={() => removeAllocation(index)}>x</div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {receipt.allocations.length < pendingSales.length &&
                                        <div className="row mt-2">
                                            <div className="col-12">
                                                <div className="btn btn-sm btn-outline-dark" onClick={() => addAllocation()}>Add Allocation</div>
                                            </div>
                                        </div>
                                    }
                                    {receipt.allocations.length > 0 &&
                                        <div className="row mt-3">
                                            <div className="col-12 text-center">
                                                <h3 className='mb-0 fw-bold'>{currencyFormat(receipt.amount)}</h3>
                                            </div>
                                        </div>
                                    }
                                    <div className="row mt-2">
                                        <div className='form-group'>
                                            <label>Notes</label>
                                            <textarea
                                                className="form-control"
                                                rows={3}
                                                value={receipt.notes}
                                                onChange={(e) => updateReceiptNotes(e)}
                                                style={{ paddingTop: "1.5rem" }}>
                                            </textarea>
                                        </div>
                                    </div>

                                    {receipt.amount > 0 &&
                                        <div className="row mt-2">
                                            <div className="col">
                                                <div className="btn btn-dark w-100" title="Save" onClick={() => saveReceipt()}>Create Receipt</div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </>
                        }
                    </div>
                </>
            }
        </div>
    );
};